import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tipalti = defineConnector({
  identifier: "tipalti",
  name: "Tipalti",
  tagLine: "Global payables automation platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.tipalti\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.tipalti.com/auth/connect/token",
        formBody: {
          grant_type: "client_credentials",
          scope: "tips.api.payables tips.api.reports",
          client_id: app.secret.clientId,
          client_secret: app.secret.clientSecret,
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Tipalti](https://www.tipalti.com/), go to **Administration → Integration → API** and create API credentials. Copy the client ID and client secret.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.tipalti.com/v3/payees?limit=1",
  },
});
